export default __webpack_public_path__ + "static/media/Iot-smart-display.9331c743.jpg";